<div class="tab-content">
  <div class="page-title">
    <h4 translate>ACTIVITIES</h4>

    <p-dialog
      *ngIf="!isPortal"
      header="{{ 'NEW_ACTIVITY' | translate }}"
      [(visible)]="displayDialog"
      [style]="{ width: '350px' }"
      [resizable]="false"
      [draggable]="false"
      showEffect="fade"
      [modal]="true"
      (onHide)="onCloseEvent()"
    >
      <form [formGroup]="newActivityForm">
        <div class="form">
          <div class="form-group" *ngIf="newActivityForm.controls['Title']">
            <label for="title">
              <span translate>TITLE</span>
              <span class="required">*</span>
            </label>
            <div>
              <input pInputText formControlName="Title" />
            </div>
            <control-messages
              [control]="newActivityForm.controls['Title']"
            ></control-messages>
          </div>
          <div class="form-group">
            <label for="description">
              <span translate>DESCRIPTION</span>
            </label>
            <div>
              <textarea pInputText formControlName="Description"></textarea>
            </div>
          </div>
        </div>
      </form>
      <div class="action-btns-wrapper">
        <button
          type="submit"
          class="btn btn-primary"
          icon="pi-check"
          label="Save"
          (click)="onSubmitTemplateBased(newActivityForm.value)"
          [disabled]="!newActivityForm.valid || saveButtonClicked"
        >
          <span translate>SAVE</span>
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary"
          icon="pi-times"
          (click)="cancel()"
        >
          <span translate>CANCEL</span>
        </button>
      </div>
    </p-dialog>

    <p-dialog
      *ngIf="isPortal"
      header="{{ 'NEW_ACTIVITY' | translate }}"
      [(visible)]="displayDialog"
      showEffect="fade"
      [modal]="true"
      [draggable]="false"
      (onHide)="onCloseEvent()"
      [style]="{ width: '550px' }"
    >
      <form [formGroup]="newActivityForm">
        <div class="form">
          <div class="col-sm-12">
            <div>
              <div class="form-group">
                <label for="status">
                  <span translate>STATUS</span>
                </label>
                <div>
                  <input pInputText readonly formControlName="Status" />
                </div>
              </div>
              <div class="form-group" *ngIf="newActivityForm.controls['Title']">
                <label for="title">
                  <span translate>TITLE</span>
                  <span class="required">*</span>
                </label>
                <div>
                  <input pInputText formControlName="Title" />
                </div>
                <control-messages
                  [control]="newActivityForm.controls['Title']"
                ></control-messages>
              </div>
              <div class="form-group">
                <label for="description">
                  <span translate>DESCRIPTION</span>
                </label>
                <div>
                  <textarea
                    pInputText
                    formControlName="Description"
                    style="height: 170px; width: 100%"
                  ></textarea>
                </div>
              </div>
            </div>
            <div *ngIf="isPortalAccess">
              <div>
                <span translate>SELECT_BUSINESS</span>
              </div>
              <div class="table-view">
                <p-table
                  #dt
                  [value]="businesses"
                  [(selection)]="selectedBusiness"
                  dataKey="value"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 55px">
                        <p-tableHeaderCheckbox
                          id="selectedBusiness"
                          (click)="BusinessCount()"
                        ></p-tableHeaderCheckbox>
                      </th>
                      <th pSortableColumn="label" style="width: 250px">
                        {{ "NAME" | translate
                        }}<p-sortIcon field="label"></p-sortIcon>
                      </th>
                    </tr>
                    <tr>
                      <th></th>
                      <th>
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter($event.target.value, 'label', 'contains')
                          "
                          placeholder=""
                          class="p-column-filter"
                        />
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-business>
                    <tr>
                      <td style="width: 55px">
                        <p-tableCheckbox
                          [value]="business"
                          (click)="BusinessCount()"
                        >
                        </p-tableCheckbox>
                      </td>
                      <td>
                        <span>{{ business.label }}</span>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
      </form>
      <br />
      <div class="" style="margin-left: 29px">
        <button
          type="submit"
          class="btn btn-primary"
          icon="pi-check"
          label="Save"
          *ngIf="isPortalAccess"
          (click)="savePortalActivity()"
          [disabled]="!newActivityForm.valid || saveButtonClicked || !showSave"
        >
          <span translate>SAVE</span>
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary"
          icon="fa-close"
          (click)="cancel()"
        >
          <span translate>CANCEL</span>
        </button>
      </div>
    </p-dialog>
  </div>

  <div class="chart-container">
    <div class="chart-header d-flex justify-content-between align-items-center mb-3">
      <div class="chart-title">
        <h4>
          <span class="year-in-title" [class.current-year]="isCurrentYear()">
            {{ selectedYear }}
          </span>
          <small class="chart-subtitle text-muted ms-2">({{ 'DEADLINE' | translate }})</small>
        </h4>
      </div>
      
      <div class="year-navigation">
        <div class="d-flex align-items-center gap-2">
          <button 
            *ngIf="isYearPaginationActive" 
            class="btn btn-outline-secondary" 
            (click)="resetToCurrentYear()"
            title="Reset to Current Year"
          >
            <i class="pi pi-refresh me-1"></i>
          </button>
          
          <button 
            class="btn btn-outline-secondary" 
            (click)="goToPreviousYear()"
            [disabled]="!canGoToPreviousYear()"
            title="Previous Year"
          >
            <i class="pi pi-chevron-left"></i>
          </button>
          
          <button 
            class="btn btn-primary" 
            (click)="goToNextYear()"
            [disabled]="!canGoToNextYear()"
            title="Next Year"
          >
            <i class="pi pi-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>

    <app-activity-list-chart
      [metadataFilter]="metadataFilter"
    ></app-activity-list-chart>
  </div>


  <div 
    class="page-actions" 
    [ngClass]="{'d-flex justify-content-between align-items-center padding-left: 0 !important': isPortal || isAdmin || isAdministrateActivity, 'd-block': !(isPortal || isAdmin || isAdministrateActivity)}" 
    style="padding-left: 0 !important;">
    <div class="selected-actions" *ngIf="isPortal || isAdmin || isAdministrateActivity">
      
      <div class="multi-action-buttons">
        <button 
          class="btn btn-delete" 
          (click)="confirmMultiDelete()"
          [disabled]="!canDeleteSelected"
          [pTooltip]="selectedActivities.length === 0 ? 'Select activities to delete' : ''"
          tooltipPosition="top"
        >
          <i class="pi pi-trash"></i>
          {{ 'DELETE' | translate }}
        </button>
        <button 
          class="btn btn-recurring" 
          (click)="confirmMultiStopRecurrence()"
          [disabled]="!canStopRecurrenceSelected"
          [pTooltip]="getStopRecurrenceTooltip()"
          tooltipPosition="top"
        >
          <i class="pi pi-refresh"></i>
          {{'STOP_RECURRINGS' | translate }}
        </button>
      </div>
      <div class="selected-counter">
        <span class="counter-text">
          {{ allSelectedActivities.size }} / {{ totalRecords }} {{ 'SELECTED' | translate }}
        </span>
        <button 
          class="btn btn-outline-primary ng-star-inserted btn-large btn-medium" 
          (click)="clearSelection()"
          *ngIf="allSelectedActivities.size > 0"
        >
          <i class="pi pi-refresh"></i>
        </button>
      </div>
    </div>
    
    <!-- New button -->
    <div *ngIf="isNewButtonEnable">
      <button 
        type="submit" 
        class="btn btn-success" 
        (click)="isPortal ? goToNewPortalActivity() : showDialogToAdd()">
        <i class="pi pi-plus"></i>
        <span translate>NEW</span>
      </button>
    </div>
  </div>
  <div class="table-view">
      <!-- Table starts -->
    <p-table
      #activityTable
      [value]="activityList"
      [rows]="paginationRequest.pageSize"
      [totalRecords]="totalRecords"
      [lazy]="true"
      [paginator]="true"
      [pageLinks]="5"
      [rowsPerPageOptions]="[10,25,50]"
      [sortMode]="'single'"
      [sortField]="paginationRequest.sortColumn"
      [sortOrder]="paginationRequest.sortDirection==='DESC'?-1:1"
      [loading]="loading"
      (onPage)="onPage($event)"
      (onSort)="onSort($event)"
      (onFilter)="onFilter($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
      [alwaysShowPaginator]="true"
      styleClass="seamless-table"
      class="activity-table"
    >
      <!-- Caption -->
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix">
          <div class="filter-controls-wrapper" [style.display]="showFilters ? 'block' : 'none'">
            <div class="kuba-filter-grid">
              <div class="filter-field" *ngIf="!isAdmin && !isPortal">
                <div class="form-group">
                  <label for="showActivity" class="col-form-label">
                    <span translate>SHOW_ACTIVITY</span>
                  </label>
                  <div>
                    <p-select
                      [options]="showActivityOptions"
                      [(ngModel)]="showActivityFilter"
                      (onChange)="onShowActivityChange($event.value)"
                      [style]="{ width: '100%' }"
                      placeholder="Select activity filter..."
                    >
                    </p-select>
                  </div>
                </div>
              </div>

              <div class="filter-field">
                <div class="form-group">
                  <label for="Year" class="col-form-label">
                    <span translate>REPETITION</span>
                  </label>
                  <div>
                    <p-select
                      type="text"
                      [options]="repetitions"
                      [filter]="true"
                      [(ngModel)]="repetitionFilter"
                      (onChange)="onRepetitionChanged(repetitionDropdown)"
                      #repetitionDropdown
                      [style]="{ width: '100%' }"
                    >
                    </p-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="kuba-filter-grid">
              <div class="filter-field" *ngIf="isPortal || isAdmin">
                <div class="form-group">
                  <label for="Year" class="col-form-label">
                    <span translate>CHOOSE_BUSINESS</span>
                  </label>
                  <div>
                    <p-select
                      [options]="businesses"
                      type="text"
                      (onChange)="onBusinessChanged(chooseBusiness)"
                      (onClear)="onBusinessCleared()"
                      #chooseBusiness
                      [filter]="true"
                      [showClear]="true"
                      [style]="{ width: '100%' }"
                      placeholder="Select business..."
                      filterPlaceholder="Search..."
                      [filterBy]="'label'"
                    >
                      <ng-template let-business pTemplate="item">
                        <div>
                          {{ business.label }}
                        </div>
                      </ng-template>
                    </p-select>
                  </div>
                </div>
              </div>
              <div class="filter-field">
                <div class="form-group">
                  <label for="Fdate">
                    <span translate>DEADLINE_FROM_DATE</span>
                  </label>
                  <div>
                    <p-datepicker
                      name="startdate"
                      [(ngModel)]="fromDateFilter"
                      [placeholder]="'SELECT_START_DATE' | translate"
                      [showIcon]="true"
                      [dateFormat]="'dd/mm/yy'"
                      (onSelect)="onStartDateChanged($event)"
                      [maxDate]="endDateFilter"
                      required
                    ></p-datepicker>
                  </div>
                </div>
              </div>
              <div class="filter-field">
                <div class="form-group">
                  <label for="Edate">
                    <span translate readonlyInput="true"
                      >DEADLINE_END_DATE</span
                    >
                  </label>
                  <div>
                    <p-datepicker
                      name="enddate"
                      [(ngModel)]="endDateFilter"
                      [placeholder]="'SELECT_END_DATE' | translate"
                      [showIcon]="true"
                      [dateFormat]="'dd/mm/yy'"
                      (onSelect)="onEndDateChanged($event)"
                      [minDate]="fromDateFilter"
                      required
                    ></p-datepicker>
                  </div>
                </div>
              </div>
              <div class="filter-field">
                <div class="form-group">
                  <label>
                    <span translate>DESCRIPTION</span>
                  </label>
                  <div>
                    <input
                      #descriptionFilterInput
                      type="text"
                      pInputText
                      (input)="onTextFilterChange('description', $any($event.target)?.value)"
                    />
                  </div>
                </div>
              </div>
            </div>
                       
          </div>
          <div class="table-options">
            <div class="pull-right filter-btn-container">
              <span
                class="current-sort-info ml-2"
                *ngIf="getActiveFiltersCount() > 0"
              >
                <small>
                  <i class="icon icon-filter"></i>
                  <span translate>ACTIVE_FILTERS</span>:
                  {{ getActiveFiltersCount() }}
                </small>
              </span>
           
              <button 
                class="btn btn-primary reset-filter-btn" 
                (click)="refreshData()"
                [disabled]="loading"
                *ngIf="getActiveFiltersCount() > 0"
              >
                <i class="pi pi-refresh me-2"></i>
                <span translate>RESET_FILTERS</span>
              </button>
              <button 
                class="btn btn-outline-primary clear-sort-btn" 
                (click)="clearSorting()"
                [disabled]="!paginationRequest.sortColumn"
              >
                <i class="pi pi-sort me-2"></i>
                <span translate>CLEAR_SORT</span>
              </button>

              <button class="btn btn-secondary" (click)="toggleFilters()">
                <span class="icon ic-sm icon-filter"></span>
                <span translate>FILTER</span>
              </button>
              <div class="action-btns-group">
                <kuba-export
                  [printMode]="1"
                  [reportData]="
                    activityTable.filteredValue || activityTable.value
                  "
                  [additionalData]="additionalData"
                  [filters]="{
                    activityNumber: noFilter || undefined,
                    businessName: businessNameFilter || undefined,
                    title: titleFilter || undefined,
                    department: departmentFilter || undefined,
                    followUp: followupFilter || undefined,
                    description: descriptionFilter || undefined,
                    responsiblePerson: responsiblePersonFilter || undefined,
                    status: selectedFilters.topic || undefined,
                    repetition: selectedFilters.repetition || undefined,
                    deadlineFrom: selectedFilters.DoneDateFrom || undefined,
                    deadlineTo: selectedFilters.DoneDateTo || undefined,
                    showActivity: showActivityFilter || undefined,
                    execution: selectedFilters.execution || undefined
                  }"
                  [exportAllData]="true"
                  [getAllDataFn]="getAllActivitiesForExport"
                  (loading)="$event ? showExportLoader() : hideExportLoader()"
                ></kuba-export>
              </div>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- Header with sortable columns -->
      <ng-template pTemplate="header">
        <tr>
          <th width="50px" style="min-width: 50px; text-align: center;" *ngIf="isPortal || isAdmin || isAdministrateActivity">
            <p-checkbox 
              [(ngModel)]="isAllSelected"
              [binary]="true"
              (onChange)="onSelectAllChange($event)">
            </p-checkbox>
          </th>
          <th pSortableColumn="No" width="130px" style="min-width: 130px;">
            {{ "NUMBER_NO" | translate }}
            <p-sortIcon field="No"></p-sortIcon>
          </th>
          <th pSortableColumn="BusinessName" width="180px" style="min-width: 180px;" *ngIf="isPortal || isAdmin">
            {{ "BUSINESS" | translate }}
            <p-sortIcon field="BusinessName"></p-sortIcon>
          </th>
          <th
            pSortableColumn="Title"
            width="250px"
            style="min-width: 250px;"
            class="activity-title-column"
          >
            {{ "TITLE" | translate }}
            <p-sortIcon field="Title"></p-sortIcon>
          </th>

          <th width="100px" style="min-width: 100px;">
            {{ "STATUS" | translate }}
          </th>
          <th width="150px" style="min-width: 150px;">
            {{ "DEPARTMENT" | translate }}
          </th>
          <th width="180px" style="min-width: 180px;">
            {{ "RESPONSIBLE_PERSON" | translate }}
          </th>
          <th width="180px" style="min-width: 180px;" *ngIf="isNotAdmin || isAdmin">
            {{ "FOLLOWUP_PERSON" | translate }}
          </th>
          <th pSortableColumn="EndDateForPdf" width="120px" style="min-width: 120px;">
            {{ "DEADLINE" | translate }}
            <p-sortIcon field="EndDateForPdf"></p-sortIcon>
          </th>

          <th pSortableColumn="CreatedOn" width="120px" style="min-width: 120px;">
            {{ "CREATED_ON" | translate }}
            <p-sortIcon field="CreatedOn"></p-sortIcon>
          </th>
          <th width="180px" style="min-width: 180px;" *ngIf="isPortal">
            {{ "CREATED_BY" | translate }}
          </th>
          <th pSortableColumn="DoneOn" width="120px" style="min-width: 120px;" *ngIf="isNotAdmin">
            {{ "DONE_ON" | translate }}
            <p-sortIcon field="DoneOn"></p-sortIcon>
          </th>
          <th width="60px" style="min-width: 60px;" *ngIf="isDisableDeleteIcon"></th>
        </tr>
        <tr>
          <th *ngIf="isPortal || isAdmin || isAdministrateActivity"></th>
          <th>
            <input
              #noFilterInput
              pInputText
              type="text"
              (input)="onTextFilterChange('no',$event.target.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th *ngIf="isPortal || isAdmin">
            <input
              #businessNameFilterInput
              pInputText
              type="text"
              (input)="onTextFilterChange('businessName',$event.target.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th class="activity-title-column">
            <input
              #titleFilterInput
              pInputText
              type="text"
              (input)="onTextFilterChange('title',$event.target.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>

          <th>
            <p-select
              width="118"
              [options]="statuses"
              #status
              (onChange)="onStatusChanged($event, status)"
              styleClass="p-column-filter"
              placeholder=""
              [showClear]="true"
              appendTo="body"
            >
              <ng-template let-status pTemplate="item">
                {{ status.label | translate }}
              </ng-template>
            </p-select>
          </th>
          <th>
            <!-- Admin level: text input with debounce, Portal/Business level: dropdown with filter -->
            <input
              #departmentFilterInput
              *ngIf="isAdmin"
              pInputText
              type="text"
              [(ngModel)]="departmentFilter"
              (input)="onTextFilterChange('department', $any($event.target)?.value)"
              class="p-column-filter"
            />
            <p-select
              *ngIf="!isAdmin"
              [(ngModel)]="selectedDepartment"
              [options]="vDepartment"
              (onChange)="onDepartmentChange($event)"
              (onClear)="onDepartmentCleared()"
              [filter]="true"
              [showClear]="true"
              [style]="{ width: '100%' }"
              [filterBy]="'label'"
              appendTo="body"
              placeholder="Select department..."
            >
              <ng-template let-department pTemplate="item">
                {{ department.label | translate }}
              </ng-template>
            </p-select>
          </th>
          <th>
            <input
              #responsiblePersonFilterInput
              pInputText
              type="text"
              (input)="onTextFilterChange('responsiblePerson',$event.target.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th *ngIf="isNotAdmin || isAdmin">
            <!-- Admin level: text input with debounce, Portal/Business level: dropdown with filter -->
            <input
              *ngIf="isAdmin"
              #followupFilterInput
              pInputText
              type="text"
              [(ngModel)]="followupFilter"
              (input)="onTextFilterChange('followup', $any($event.target)?.value)"
              class="p-column-filter"
            />
            <p-select
              *ngIf="!isAdmin"
              [(ngModel)]="selectedFollowUpPerson"
              [options]="follows"
              (onChange)="onFollowupSelected($event)"
              (onClear)="onFollowupCleared()"
              [filter]="true"
              [showClear]="true"
              [style]="{ width: '100%' }"
              [filterBy]="'label'"
              placeholder="Select responsible person..."
              filterPlaceholder="Search..."
              appendTo="body"
            >
              <ng-template let-person pTemplate="item">
                <div>
                  {{ person.label }}
                </div>
              </ng-template>
            </p-select>
          </th>
          <th></th>

          <th></th>
          <th *ngIf="isPortal">
            <input
              #createdByNameFilterInput
              pInputText
              type="text"
              (input)="onTextFilterChange('createdByName',$event.target.value)"
              placeholder=""
              class="p-column-filter"
            />
          </th>
          <th *ngIf="isNotAdmin"></th>
          <th *ngIf="isDisableDeleteIcon"></th>
        </tr>
      </ng-template>

      <!-- Body Content -->
      <ng-template pTemplate="body" let-activity>
        <tr>
          <td class="checkbox-column" style="text-align: center;" *ngIf="isPortal || isAdmin || isAdministrateActivity">
            <p-checkbox 
              [binary]="true"
              [ngModel]="isActivitySelected(activity)"
              [disabled]="activity.StatusId === 9"
              (onChange)="onActivitySelectionChange({checked: $event.checked, data: activity})"
              [pTooltip]="getActivityRecurringTooltip(activity)"
              tooltipPosition="top">
            </p-checkbox>
          </td>
          <td class="ng-star-inserted">
            <div class="status-and-number">
              <div class="status-icon">
                <i
                  *ngIf="activity.StatusId == 10"
                  class="{{ activity.StatusData.StatusIcon }}"
                  style="color: red"
                ></i>
                <i
                  *ngIf="activity.StatusId != 10"
                  class="{{ activity.StatusData.StatusIcon }}"
                ></i>
              </div>
              <span
                pTooltip="{{ activity.No }}"
                tooltipPosition="top"
                translate
                >{{ activity.No }}</span
              >
              <!-- Recurring icon for portal level -->
              <i 
                *ngIf="(isPortal || isAdmin || isAdministrateActivity) && isActivityRecurring(activity)"
                class="pi pi-refresh recurring-icon"
                pTooltip="{{ 'RECURRING_ACTIVITY' | translate }}"
                tooltipPosition="top"
                title="{{ 'RECURRING_ACTIVITY' | translate }}"
              >              </i>
            </div>
          </td>
          <td *ngIf="isPortal || isAdmin">
            <span
              translate
              pTooltip="{{ activity.BusinessName }}"
              tooltipPosition="right"
              class="text-overflow"
              >{{ activity.BusinessName }}</span
            >
          </td>
          <td class="activity-title-column" *ngIf="isEditor">
            <a
              [routerLink]="['./edit', activity.Id]"
              [class.disabled]="activity.RoleId === '1'"
              pTooltip="{{ activity.Title }}"
              tooltipPosition="right"
              class="activity-title-text text-overflow"
              >{{ activity.Title }}</a
            >
          </td>
          <td class="activity-title-column" *ngIf="!isEditor">
            <a
              *ngIf="activity.Responsible === true && !isPortal"
              [routerLink]="['./edit', activity.Id]"
              pTooltip="{{ activity.Title }}"
              tooltipPosition="right"
              class="activity-title-text text-overflow"
            >
              {{ activity.Title }}
            </a>
            <a
              *ngIf="isPortal"
              [routerLink]="['./portal-edit', activity.Id]"
              [state]="{ activityData: activity }"
              pTooltip="{{ activity.Title }}"
              tooltipPosition="right"
              class="activity-title-text text-overflow"
            >
              {{ activity.Title }}
            </a>
            <span
              *ngIf="activity.Responsible !== true && !isPortal"
              pTooltip="{{ activity.Title }}"
              tooltipPosition="right"
              class="activity-title-text text-overflow"
            >
              {{ activity.Title }}
            </span>
          </td>

          <td>
            <span translate>{{ activity.Status }}</span>
          </td>
          <td>
            <span [innerHTML]="activity.Department" class="text-overflow"></span>
          </td>
          <td class="person-column">
            <span 
              class="person-list" 
              [pTooltip]="activity.ExecutionUserList"
              tooltipPosition="top"
              [escape]="false"
            >{{ truncatePersonList(activity.ExecutionUserList) }}</span>
          </td>
          <td class="person-column" *ngIf="isNotAdmin || isAdmin">
            <span 
              class="person-list" 
              [pTooltip]="activity.FollowupUserList"
              tooltipPosition="top"
              [escape]="false"
            >{{ truncatePersonList(activity.FollowupUserList) }}</span>
          </td>
          <td class="date-column">
            <span translate *ngIf="activity.Status !== 'NEW'">{{
              activity.EndDateForPdf
            }}</span>
          </td>

          <td class="date-column">
            <span translate>{{ activity.CreatedOnForPdf }}</span>
          </td>
          <td *ngIf="isPortal">
            <span
              pTooltip="{{ activity.CreatorName }}"
              tooltipPosition="top"
              class="text-overflow"
              >{{ activity.CreatorName }}</span
            >
          </td>
          <td class="date-column" *ngIf="isNotAdmin">
            <span translate>{{
              activity.CompletedDate | date: "dd/MM/yyyy"
            }}</span>
          </td>
          <td class="col-button" *ngIf="isDisableDeleteIcon">
            <button
              type="button"
              *ngIf="activity.StatusId !== 9 && activity.RepetitionId <= 1"
              (click)="confirm(activity.Id)"
              title="{{ 'DELETE' | translate }}"
              [disabled]="
                activity.RoleId === 'Portal' && activity.StatusId === 9
              "
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
            <button
              type="button"
              *ngIf="
                activity.StatusId !== 9 &&
                activity.RepetitionId > 1 &&
                roleId === '3'
              "
              class="btn btn-icon"
              (click)="showDialogForStopFutureRecurring(activity)"
            >
              <i class="icon ic-sm icon-032"></i>
            </button>
          </td>
        </tr>
      </ng-template>

      <!-- Footer -->
      <ng-template pTemplate="summary">
        <div class="ui-helper-clearfix">
          <div class="footer-data">
            <div class="symbol-descriptions">
              <div class="symbol-desc-title">
                <span translate>DESCRIPTION_SYMBOLS</span>
              </div>
              <div class="symbol-desc-items">
                <span class="new-deadline">
                  <i class="icon ic-md icon-new-deadline"></i>
                  <span translate>NEW_ACTIVITY</span>
                </span>
                <span class="far-deadline">
                  <i class="icon ic-md icon-far-deadline"></i>
                  <span translate>TIME_REMAINING</span>
                </span>
                <span class="over-deadline">
                  <i class="icon ic-md icon-over-deadline"></i>
                  <span translate>OVERDEADLINE</span>
                </span>
                <span class="near-deadline">
                  <i class="icon ic-md icon-near-deadline"></i>
                  <span translate>PERIOD</span>
                </span>
                <span class="clear-deadline">
                  <i class="icon ic-md icon-clear-deadline"></i>
                  <span translate>DONE_STATUS</span>
                </span>
                <span class="clear-deadline" style="color: red">
                  <i class="icon ic-md icon-cancel"></i>
                  <span translate>REJECTED</span>
                </span>
                <!-- Recurring icon description for portal level -->
                <span class="recurring-symbol" *ngIf="isPortal || isAdmin || isAdministrateActivity">
                  <i class="pi pi-refresh recurring-icon"></i>
                  <span translate>RECURRING_ACTIVITY</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </p-table>
    <!-- Table Ends -->
  </div>
  <p-confirmDialog
    header="{{ 'CONFIRMATION' | translate }}"
    icon="pi pi-exclamation-triangle"
    [style]="{ width: '500px', minWidth: '500px', maxWidth: '500px' }"
    acceptLabel="{{ 'SWITCH_YES' | translate }}"
    rejectLabel="{{ 'SWITCH_NO' | translate }}"
  ></p-confirmDialog>
  <p-dialog
    header="{{ 'CONFIRMATION' | translate }}"
    [(visible)]="displayDialogForRecurring"
    [style]="{ width: '350px' }"
    [resizable]="false"
    [draggable]="false"
    showEffect="fade"
    [modal]="true"
    [closable]="true"
  >
    <div class="confirmation-content">
      <div class="pi pi-exclamation-triangle">
        <span style="font-family: Arial, sans-serif">
          {{ "STOP_DELETE_FUTURE_RECURRING_ACTIVITIES" | translate }}</span
        >
      </div>
    </div>
    <div class="action-btns-wrapper">
      <button
        type="submit"
        class="btn btn-outline-primary"
        [disabled]="IsFutureRecurring"
        label="Save"
        (click)="onClickStopFutureRecurring()"
      >
        <span translate>STOP_FUTURE_RECURRING</span>
      </button>
      <button
        type="button"
        class="btn btn-danger"
        (click)="onClickDeleteRecurringActivity()"
      >
        <span translate>DELETE</span>
      </button>
    </div>
  </p-dialog>
</div>

<export-progress-dialog [visible]="exportInProgress"></export-progress-dialog>

<!-- Progress Loader for Multi-Delete and Stop Recurrence -->
<app-progress-loader 
  #progressLoader
  [config]="progressLoaderConfig">
</app-progress-loader>

